var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStepperGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 157523"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 8",
    cx: 12,
    cy: 11.9231,
    rx: 12,
    ry: 11.9231,
    fill: "#B8C5CC"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 9",
    cx: 12,
    cy: 11.9615,
    rx: 6,
    ry: 5.96154,
    fill: "#191F23"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepperGroup);
export default __webpack_public_path__ + "static/media/stepper_Group.90953c77dc6d7731f41c8965b805999f.svg";
export { ForwardRef as ReactComponent };